"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createEditorViewState(content, isDirty, cursorStyle) {
    if (cursorStyle === void 0) { cursorStyle = ''; }
    return {
        content: content,
        isDirty: isDirty,
        cursorStyle: cursorStyle,
    };
}
exports.default = createEditorViewState;
//# sourceMappingURL=createEditorViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-editor/lib/utils/createEditorViewState.js
// module id = 3735
// module chunks = 2